import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { ArrowDirection, ArrowIcon } from '../../atoms/icons/arrow_icon';
export const SearchFilterChips = ({ chips, onClick }) => {
    return (React.createElement("div", { className: css(styles.chips) }, chips.map((chip) => (React.createElement("div", { key: chip.key, className: css(styles.filterChip, chip.active && styles.filterChipActive), onClick: () => onClick(chip.key) },
        chip.label,
        React.createElement(ArrowIcon, { direction: ArrowDirection.bottom, color: chip.active ? Colors.PrimaryDark : Colors.GrayDarkest, classObject: styles.chevron }))))));
};
const styles = StyleSheet.create({
    chips: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
            width: 0,
            height: 0,
        },
        gap: 8,
        marginTop: 12,
        marginLeft: -16,
        marginRight: -16,
        paddingLeft: 16,
        paddingRight: 16,
        [MediaBreakPointUp.MD]: {
            flexWrap: 'nowrap',
            overflowX: 'hidden',
            gap: 4,
            marginLeft: -23,
            marginRight: -23,
            paddingLeft: 23,
            paddingRight: 23,
        },
        [MediaBreakPointUp.XL]: {
            overflowX: 'visible',
            gap: 8,
            marginLeft: -32,
            marginRight: -32,
            paddingLeft: 32,
            paddingRight: 32,
        },
    },
    filterChip: {
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: 4,
        border: `1px solid ${Colors.BorderLightGrayB}`,
        background: Colors.White,
        borderRadius: 16,
        padding: '6px 12px',
        fontSize: 13,
        color: Colors.TextDark,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        [MediaBreakPointUp.MD]: {
            padding: '6px 7.5px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '6px 12px',
        },
    },
    filterChipActive: {
        color: Colors.TextDark,
        borderColor: Colors.PrimaryDark,
        background: Colors.PrimaryLighter,
    },
    chevron: {
        width: 12,
        height: 12,
    },
});
